import { apiRequest } from './client';

// Admin: supplier URLs and credentials and the website URL (see /api/admin/supplier-settings).

/** { groups: [{ id, title, description, settings: [{ key, label, kind, value, hasValue, hint, source, liveValue, … }] }] } */
export const adminGetSupplierSettings = (token) => apiRequest('/api/admin/supplier-settings', { token });

/** changes: [{ key, value }] to save, or [{ key, reset: true }] to go back to the appsettings value. */
export const adminSaveSupplierSettings = (token, changes) =>
  apiRequest('/api/admin/supplier-settings', { method: 'PUT', body: changes, token });

/** Calls the supplier with the saved settings: { ok, checks: [{ name, ok, message }] }. */
export const adminTestSupplier = (token, group) =>
  apiRequest(`/api/admin/supplier-settings/${encodeURIComponent(group)}/test`, { method: 'POST', token });
